import React from 'react';

const WhyUs: React.FC = () => {
  return (
    <section className="why-us-section bg-gray-100 py-16">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">¿Por qué elegir Sicons Peru?</h2>
        <p className="text-lg md:text-xl mb-12">
          En Sicons Peru, te ofrecemos un servicio personalizado y adaptado a tus necesidades específicas. Nuestro equipo de expertos te brindará soluciones integrales y eficientes para impulsar el crecimiento de tu empresa.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Ventaja 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Experiencia y Profesionalismo</h3>
            <p>Contamos con un equipo altamente capacitado y con amplia experiencia en el sector financiero y contable.</p>
          </div>
          {/* Ventaja 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Soluciones a Medida</h3>
            <p>Adaptamos nuestros servicios a las necesidades particulares de cada cliente, brindando soluciones personalizadas y efectivas.</p>
          </div>
          {/* Ventaja 3 */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Tecnología de Vanguardia</h3>
            <p>Utilizamos las últimas herramientas tecnológicas para garantizar la eficiencia y precisión en nuestros servicios.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
